import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FilterListService, ConfigService, RenderFilter } from 'gung-list';
import { InvoiceListConfigService } from '../invoice-list-config/invoice-list-config.service';
import { NavigationConfig } from '../../models/navigation-config';

@Injectable({
  providedIn: 'root'
})
export class GungFilterListService<T> extends FilterListService<T> {
  constructor(
    protected route: ActivatedRoute,
    protected translationService: TranslateService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(route);
  }

  getFilteredList(
    items: T[],
    searchTerms: Record<string, string>,
    configService: ConfigService<T>,
    filters: RenderFilter[]
  ): T[] {
    const result = super.getFilteredList(items, searchTerms, configService, filters);
    if (this.environment.standardErp && configService instanceof InvoiceListConfigService) {
      if (result.filter((x: any) => x.id === this.translationService.instant('TOTAL')).length === 0) {
        const amountIncludingVat = result.reduce((prev, curr) => prev + ((curr as any)?.extra.gme?.amountIncludingVat ?? 0), 0);
        const amountPaid = result.reduce((prev, curr) => prev + ((curr as any)?.extra.gme?.amountPaid ?? 0), 0);
        result.unshift({
          id: this.translationService.instant('TOTAL'),
          name: '',
          extra: {
            gme: {
              currencyCode: (result?.[0] as any)?.extra?.gme?.currencyCode,
              amountIncludingVat,
              amountPaid
            }
          }
        } as any);
      }
    }
    return result;
  }
}